import './about-block.scss';

export default () => {

};
